// メッセージ
export const Messages = {
    DEVICE_LIST_ADD: '追加しました。',
};

// エラーメッセージ
export const ErrorMessages = {
    DEVICE_LIST_ADD_ERROR: '見積り機種に登録できるのは10明細までです。',
    DEVICE_LIST_ERROR_CONTACT: '11明細以上のお見積もりをご希望の方は、お問い合わせフォームをご利用ください。',

    // 見積情報入力
    EST_VAL01: '一度に追加できるのは10台までです。',
    EST_VAL02: '期間の終了年月は開始年月以降を設定してください。',
    EST_VAL03: 'マイリストに機種がありません。',
    EST_VAL04: '保守期間の開始年月は来月以降を設定してください。',

    // 見積り機器編集
    INQ_DEVICE_VAL01: '見積り機器が1件もありません。見積り機器の追加をお願いします。',
    INQ_DEVICE_VAL02: '見積り機器（%1）の備考は512文字以内で入力してください。',

    // 見積り条件編集
    INQ_EST_VAL01: '見積り条件が1件もありません。見積り条件の追加をお願いします。',
    INQ_EST_VAL02: '見積り条件%1の名称を入力してください。',
    INQ_EST_VAL03: '期間の終了年月は開始年月以降を設定してください。',
    INQ_EST_VAL04: '保守期間の開始年月は来月以降を設定してください。',
    INQ_EST_VAL05: '見積り条件%1の名称は512文字以内で入力してください。',
    INQ_EST_VAL06: '見積り条件名称が重複して入力されています。重複しないように入力をお願いいたします。',
    INQ_EST_VAL07: '見積り情報が何も選択されていません。見積り情報をチェック選択して下さい。',

    // 問い合わせ
    CONTACT_VAL01: 'お問い合わせ詳細・備考は512文字以内で入力してください。',
    CONTACT_VAL02: '必須入力です。',
    CONTACT_VAL02_MODAL: '必須項目を入力してください。',

    // 個人情報入力
    CI_VAL01: '電話番号の形式をご確認ください。',
    CI_VAL02: 'メールアドレスの形式をご確認ください。',
    CI_VAL03: 'メールアドレスが確認欄と一致しません。',
    CI_VAL04: '%1は%2文字以内で入力してください。',
    CI_VAL05: '%1は必須入力です。',
    CI_VAL05_MODAL: '必須項目を入力してください。',
    CI_VAL05_P_POLCIY: '個人情報保護方針同意チェックはチェック必須です。',

    // 一時保存画面
    TEMP_MAIL_VAL01: 'メールアドレスの形式をご確認ください。',
    TEMP_MAIL_VAL02: 'メールアドレスが入力されていません。',

    // 確認画面
    CONFIRM_SEND_ERROR: 'お問い合わせ送信時に異常が発生しました。',

    // APIエラー応答
    API2201_VALD_ERROR: '送信内容に異常が発生しました。(API2201_%1)',
    API2202_VALD_ERROR: '送信内容に異常が発生しました。(API2202_%1)',
    API2203_VALD_ERROR: '送信内容に異常が発生しました。(API2203_%1)',
    API300x_SEARCH_ERROR: '検索処理が失敗しました。(API_%1)',
    API4001_VALD_ERROR: '送信内容に異常が発生しました。(API4001_%1)',
    API4002_VALD_ERROR: 'リキャプチャ処理に異常が発生しました。(API4002_%1)',
    API5001_VALD_ERROR: '送信内容に異常が発生しました。(API5001_%1)',
    API5002_VALD_ERROR: '送信内容に異常が発生しました。(API5002_%1)',
    API5003_SEND_ERROR: 'メール送信が失敗しました。(API5003_%1)',
    API5003_SEND_ERROR_OTHER: 'メール送信が失敗しました。',
    API8001_INIT_ERROR: '初期処理にて異常が発生しました。(API8001_%1)',
    API900x_INIT_ERROR: 'マスタ取得処理にて異常が発生しました。(API_%1)',
};
